import React from "react";
import { useNavigate } from "react-router-dom";
import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";
import { apiPath, RoutePath } from "../../utility/Constant";
import useFetch from "../../hooks/useFetch";

const ClientCreate = () => {
  const { clientsApi } = apiPath;
  const { clients } = RoutePath;
  const navigate = useNavigate();
  // data
  const [clientsData] = useFetch(clientsApi);
  // get "clientsList" array
  const clientsList = clientsData.clientsList;

  const data = [
    {
      elementType: "file",
      label: "Client Image",
      type: "Text",
      name: "url",
      required: true,
    },
    {
      elementType: "textField",
      label: "Client Title",
      type: "Text",
      name: "title",
      required: false,
    },
  ];

  const update = (data) => {
    clientsList.push(data);
    const newArray = { clientsList: clientsList };
    updateData(`${clientsApi}`, newArray, null, null, null, null);
    setTimeout(() => {
      navigate("/" + clients);
    }, 1000);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default ClientCreate;
